<template>
  <v-card class="pa-0 ma-0">
    <v-card-text class="pt-2 pa-1">
      <v-form>
        <v-layout row wrap>
          <v-flex xs8 pa-1>
            <v-text-field label="Codice" box hide-details
              :value="$functions.getCodArticoloFormat(datiArticolo.cdArticolo)" :append-icon="'search'"
              v-on:input="cdArticolo = $event" @click:append="caricaDati()" ref="txtArt"></v-text-field>
          </v-flex>
          <v-flex xs4 pa-1>
            <v-text-field label="Ubicazione" v-model="datiArticolo.ubicazione" box hide-details
              ref="txtUbicaz"></v-text-field>
          </v-flex>
          <v-flex xs12 pa-1>
            <v-textarea label="Descrizione" v-model="datiArticolo.descrizione" box readonly hide-details
              rows="2"></v-textarea>
          </v-flex>
          <v-flex xs9 pa-1>
            <v-text-field label="Codice fornitore" v-model="datiArticolo.cdArticoloFornitore" box readonly
              hide-details></v-text-field>
          </v-flex>
          <v-flex xs3 pa-1>
            <v-text-field label="UM" v-model="datiArticolo.unMisura" box readonly hide-details></v-text-field>
          </v-flex>
          <v-flex xs6 pa-1>
            <v-text-field label="Quantità" v-model.number="datiArticolo.qta" box hide-details type="number"
              ref="txtQta"></v-text-field>
          </v-flex>
          <v-flex xs6 pa-1>
            <v-text-field label="Quantità fuori posto" v-model.number="datiArticolo.qtaFuoriPosto" box hide-details
              type="number"></v-text-field>
          </v-flex>
        </v-layout>

        <!-- Bottone conferma -->
        <v-layout>
          <v-flex xs4 pa-1></v-flex>
          <v-flex xs4 pa-1>
            <v-btn block dark large @click="registraScorta()" :loading="attesaConferma" :disabled="attesaConferma"
              color="primary">Conferma</v-btn>
          </v-flex>
        </v-layout>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import { get_datiArticoli, scortaArticolo } from "@/api/api.js";

export default {
  props: {
    articolo: { type: String, default: "" }
  },
  data: () => ({
    datiArticolo: {},
    cdArticolo: "",
    salvato: false,

    attesaConferma: false
  }),

  methods: {
    caricaDati() {
      // Reset
      this.datiArticolo = {};
      this.salvato = false;

      if (!this.cdArticolo) return;

      // Elimino spazi di formattazione codice
      this.cdArticolo = this.$functions.trimAll(this.cdArticolo);

      get_datiArticoli(this.cdArticolo)
        .then(res => {
          this.datiArticolo = res.data;

          this.$refs["txtQta"].focus();
        })
        .catch(err => {
          console.log(err);
          this.$toast.warning(this.$functions.getErrorMsg(err));
        })
        .finally(() => "");
    },

    registraScorta() {
      // Controllo presenza dati articolo
      if (Object.keys(this.datiArticolo).length == 0) {
        this.$toast.warning("Articolo non valido");
        return false;
      }

      // Controllo qta
      if (
        this.$functions.isNumber(this.datiArticolo.qta) == false ||
        this.$functions.isNumber(this.datiArticolo.qtaFuoriPosto) == false
      ) {
        this.$toast.warning("Quantità non valida");
        return false;
      }

      this.attesaConferma = true;

      // Utente
      this.datiArticolo.utente = this.$store.getters["user/getUser"];

      scortaArticolo(this.datiArticolo)
        .then(res => {
          this.salvato = true;

          // Controllo se è stato richiamato da un ordine, per aggiornare la qtaScaffale
          if (this.fromOrdine) {
            this.$emit("chiudi", this.salvato);
          } else {
            // Reset
            this.datiArticolo = {};
            this.$refs["txtArt"].focus();
          }
        })
        .catch(err => {
          console.log(err);
          this.$toast.info(this.$functions.getErrorMsg(err));
        })
        .finally(() => (this.attesaConferma = false));
    },


  },

  mounted() { },

  computed: {
    getCodebar() {
      return this.$store.getters["app/getCodebar"];
    },

    fromOrdine() {
      return !!this.articolo;
    }
  },

  watch: {
    getCodebar(v) {
      // NOTA: viene attivato dal lettore codebar

      if (this.$refs.txtUbicaz.isFocused) {
        this.datiArticolo.ubicazione = v.barcodeData;

        return;
      } else {
        this.cdArticolo = v.barcodeData;

        this.caricaDati();
      }
    },

    articolo() {
      // NOTA: viene attivato dalla videata degli ordini

      this.cdArticolo = this.articolo;

      this.caricaDati();
    }
  }
};
</script>
